// @flow
import { Action, ConditionName } from './type'

export type ErrorAction = Action & {
  type: 'SET_ERROR' | 'CLEAR_ERROR'
}

export const SET_ERROR = 'SET_ERROR'
export const setError = (name: ConditionName[]) => ({
  type: SET_ERROR,
  payload: name,
})

export const CLEAR_ERROR = 'CLEAR_ERROR'
export const clearError = () => ({ type: CLEAR_ERROR })
